import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { RouteData } from "../app-routing.module";
import { RoleName } from "../classes/flow/session/Session";
import { AuthService } from "../services/auth.service";
import { filter, firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class HasRoleGuard {
  private router = inject(Router);
  private auth = inject(AuthService);

  public async canActivate(routeSnapshot: ActivatedRouteSnapshot) {
    return await this.checkForRequiredRoles(routeSnapshot);
  }

  public async canActivateChild(routeSnapshot: ActivatedRouteSnapshot) {
    return await this.checkForRequiredRoles(routeSnapshot);
  }

  private async checkForRequiredRoles(routeSnapshot: ActivatedRouteSnapshot) {
    const data = routeSnapshot.data as RouteData;

    console.log(this.auth.ready.value);
    await firstValueFrom(this.auth.ready.pipe(filter((x) => !!x)));
    console.log(data, this.auth.session.value, this.auth.roleName);

    if (data.allowedRoles?.some((x) => this.hasPermission(x))) {
      return true;
    }

    return this.router.createUrlTree(data.noAuthRedirectURL ? [data.noAuthRedirectURL] : ["error/403"]);
  }

  private hasPermission(role: RoleName) {
    if (role === "coach") return this.auth.isCoach();
    if (role === "coordinator") return this.auth.isCoordinator();
    if (role === "resident") return this.auth.isResident();
    if (role === "guest") return !this.auth.session.value;
    return false;
  }
}
